import React from 'react';
import { Route, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Breadcrumbs.css';
import * as PageConstants from '../../../constants/PageTitle';

const Breadcrumbs = () => <Route path="*" render={props => {
    let parts = props.location.pathname.split("/");
    const place = parts[parts.length - 1];
    parts = parts.slice(1, parts.length - 1);
    return <div className="crumb">{parts.map(crumb)}<span className="link-map current-page">{getPartName(place)}</span></div>
}} />

const crumb = (part, partIndex, parts) => {
    const path = ['', ...parts.slice(0, partIndex + 1)].join("/");
    return <Link key={path} to={path}><span className="link-map">{getPartName(part)}</span>&gt;</Link>
}

const getPartName = (part) => {
    switch (part) {
        case PageConstants.INTRODUCTION:
            return PageConstants.INTRO_TITLE;
        case PageConstants.TECHNICAL:
            return PageConstants.TECHNICAL_TITLE;
        case PageConstants.TERM:
            return PageConstants.TERM_TITLE;
        case PageConstants.HANDOVER:
            return PageConstants.HANDOVER_TITLE;
        case PageConstants.IMG_DELIVERY:
            return PageConstants.IMG_DELIVERY_TITLE;
        case PageConstants.IMG_DELIVERY2:
            return PageConstants.IMG_DELIVERY2_TITLE;
        case PageConstants.GET_IMAGE:
            return PageConstants.GET_IMAGE_TITLE;
        case PageConstants.GET_NEXT_IMAGE:
            return PageConstants.GET_NEXT_IMAGE_TITLE;
        case PageConstants.SEND_RECEIPT:
            return PageConstants.SEND_RECEIPT_TITLE;
        case PageConstants.IMAGE_INFORMATION_ROUTE:
            return PageConstants.IMAGE_INFORMATION_TITLE;
        case PageConstants.IMAGE_INFORMATION_V1_ROUTE:
            return PageConstants.IMAGE_INFORMATION_V1_TITLE;
        case PageConstants.IMAGE_INFORMATION_V2_ROUTE:
            return PageConstants.IMAGE_INFORMATION_V2_TITLE;
        case PageConstants.SET_TRANSACTION_APPROVAL_STATE_V2:
            return PageConstants.SET_TRANSACTION_APPROVAL_STATE_V2_TITLE;
        case PageConstants.IMAGE_INFORMATION_V3_ROUTE:
            return PageConstants.IMAGE_INFORMATION_V3_TITLE;
        case PageConstants.SET_CUSTOM_DATA_CAPTURE:
            return PageConstants.SET_CUSTOM_DATA_CAPTURE_TITLE;
        case PageConstants.SET_EMAIL_ADDRESS:
            return PageConstants.SET_EMAIL_ADDRESS_TITLE;
        case PageConstants.SET_TRANSACTION_APPROVAL_STATE_V3:
            return PageConstants.SET_TRANSACTION_APPROVAL_STATE_TITLE;
        case PageConstants.IMAGE_INFORMATION_V4_ROUTE:
            return PageConstants.IMAGE_INFORMATION_V3_TITLE;
        case PageConstants.SET_PRODUCT_SWAP:
            return PageConstants.SET_PRODUCT_SWAP_TITLE;
        case PageConstants.GALLERY_API:
            return PageConstants.GALLERY_API_TITLE
        case PageConstants.ECHO:
            return PageConstants.ECHO_TITLE
        case PageConstants.GET_CATEGORY_LIST:
            return PageConstants.GET_CATEGORY_LIST_TITLE;
        case PageConstants.GET_CATEGORY_COUNT:
            return PageConstants.GET_CATEGORY_COUNT_TITLE;
        case PageConstants.GET_CATEGORY_IMAGE_LIST:
            return PageConstants.GET_CATEGORY_IMAGE_LIST_TITLE;
        case PageConstants.GET_CATEGORY_IMAGE_COUNT:
            return PageConstants.GET_CATEGORY_IMAGE_COUNT_TITLE;
        case PageConstants.SEARCH_IMAGES:
            return PageConstants.SEARCH_IMAGES_TITLE
        case PageConstants.CREATE_GALLERY_CARD:
            return PageConstants.CREATE_GALLERY_CARD_TITLE
        case PageConstants.DATA_CAPTURE_MATCHING_HANDLER:
            return PageConstants.DATA_CAPTURE_MATCHING_HANDLER_TITLE
        case PageConstants.STEPBYSTEP:
            return PageConstants.STEPBYSTEP_TITLE
        case PageConstants.AAM_NEW_PROGRAM_GUIDE:
            return PageConstants.AAM_NEW_PROGRAM_GUIDE_TITLE
        case PageConstants.PUBLIC_DESIGN_HANDLER:
            return PageConstants.PUBLIC_DESIGN_HANDLER_TITLE
        case PageConstants.COMPETITION_API:
            return PageConstants.COMPETITION_API_TITLE
        case PageConstants.ADD_VOTE:
            return PageConstants.ADD_VOTE_TITLE
        case PageConstants.GET_CAPTCHA:
            return PageConstants.GET_CAPTCHA_TITLE
        case PageConstants.GET_DESIGN:
            return PageConstants.GET_DESIGN_TITLE
        case PageConstants.GET_DESIGN_COUNT:
            return PageConstants.GET_DESIGN_COUNT_TITLE
        case PageConstants.GET_DESIGN_LIST:
            return PageConstants.GET_DESIGN_LIST_TITLE
        case PageConstants.GET_TOP_VOTED:
            return PageConstants.GET_TOP_VOTED_TITLE
        case PageConstants.SET_PUBLIC_DESIGN:
            return PageConstants.SET_PUBLIC_DESIGN_TITLE
        case PageConstants.AAM_GALLERY_SETUP_GUIDE:
            return PageConstants.AAM_GALLERY_SETUP_GUIDE_TITLE
        case PageConstants.AAM_USER_MANAGEMENT:
            return PageConstants.AAM_USER_MANAGEMENT_TITLE
        case PageConstants.IMAGE_SHARE_GUIDE:
            return PageConstants.IMAGE_SHARE_GUIDE_TITLE
        case PageConstants.IMAGE_DELIVERY_SCRIPT:
            return PageConstants.IMAGE_DELIVERY_SCRIPT_TITLE
        case PageConstants.REPORTING_GUIDE:
            return PageConstants.REPORTING_GUIDE_TITLE
        case PageConstants.IMAGECHECKING_GUIDE:
            return PageConstants.IMAGECHECKING_GUIDE_TITLE
        case PageConstants.APPEALS_PROCESS:
            return PageConstants.APPEALS_PROCESS_TITLE
        case PageConstants.ClipArt_Gallery:
            return PageConstants.ClipArt_Gallery_TITLE
        case PageConstants.Image_Validator:
            return PageConstants.Image_Validator_TITLE
        case PageConstants.Upload_Image:
            return PageConstants.Upload_Image_TITLE
        case PageConstants.SEND_IMAGE:
            return PageConstants.SEND_IMAGE_TITLE
        case PageConstants.SEND_IMAGE_DATA_CAPTURE:
            return PageConstants.SEND_IMAGE_DATA_CAPTURE_TITLE
        case PageConstants.HTML_PLUGIN_INTEGRATION:
            return PageConstants.HTML_PLUGIN_INTEGRATION_TITLE
        case PageConstants.IMAGE_HUB:
            return PageConstants.IMAGE_HUB_TITLE
        case PageConstants.SIGNATUREONCARD:
            return PageConstants.SIGNATUREONCARD_TITLE
        case PageConstants.SAMLSSO:
            return PageConstants.SAMLSSO_TITLE
        case PageConstants.IMG_PURGE:
            return PageConstants.IMG_PURGE_TITLE;
        case PageConstants.SET_IMAGE_TO_PURGE:
            return PageConstants.SET_IMAGE_TO_PURGE_TITLE;
        default:
            return PageConstants.TERM_TITLE + '(' + part + ')';
    }
}

Breadcrumbs.propTypes = {
    location: PropTypes.object,
    pathname: PropTypes.string
}

export default Breadcrumbs;